import { ListResponse, PaginationRequest, Response } from './client/types'
import { useAPI } from './client/useAPI'
import { InvoiceListItem, Invoice } from '../../lib/types/Invoice'

export type InvoicesRequest = PaginationRequest & {
  companyId?: string
  createdAtFrom?: string
  createdAtTo?: string
  paidAtFrom?: string
  paidAtTo?: string
}

type InvoicesResponse = ListResponse<InvoiceListItem>

export const useInvoices = () => {
  return useAPI<InvoicesResponse, InvoicesRequest>('GET', '/invoices', {
    withToken: true,
  })
}

type InvoiceResponse = Response<Invoice>
export type InvoiceRequest = {
  companyId: string
}

export const useInvoice = (id: string) => {
  return useAPI<InvoiceResponse, InvoiceRequest>('GET', `/invoices/${id}`, {
    withToken: true,
  })
}

export type DownloadInvoiceRequest = {
  companyId: string
}
export const useDownloadInvoice = (id: string) => {
  return useAPI<any, DownloadInvoiceRequest>('GET', `/invoices/${id}`, {
    withToken: true,
    isPdf: true,
  })
}

type PayInvoiceResponse = Response<Invoice>
export const usePayInvoice = (id: string) => {
  return useAPI<PayInvoiceResponse>('POST', `/invoices/${id}/complete`, {
    withToken: true,
  })
}
